import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "avatar"
}
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = {
  key: 0,
  class: "crop-image"
}
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "crop" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "actions" }

import { ref, watch, onBeforeUnmount, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { svgIcon, viewImage } from "@/common/components";

import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-avatar',
  props: {
    url: { default: null },
    size: { default: "9rem" },
    isEdit: { type: Boolean, default: false },
    showImage: { type: Boolean, default: false },
    showEdit: { type: Boolean, default: true },
    showUpload: { type: Boolean, default: true },
    showDel: { type: Boolean, default: true },
    background: { default: "#eeeeee" },
    borderRadius: { default: "50%" },
    position: { default: "right" },
    aspectRatio: {},
    viewMode: { default: 1 }
  },
  emits: ["change", "del"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v20814ab8": (props.size),
  "v298214d6": (props.aspectRatio ?? 1),
  "v17b22bb2": (_ctx.background)
}))

const { t } = useI18n();

const emit = __emit;

const props = __props;

const fileInput = ref();

const internalShowImage = ref(false);
const internalShowCrop = ref(true);

const imageUrl = ref<string | null>(null);
const imageElement = ref<HTMLImageElement | null>(null);

const cropper = ref<Cropper | null>(null);

function fileSelect(event: any) {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      imageUrl.value = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }
}

function cropImage() {
  if (cropper.value) {
    internalShowCrop.value = false;
    store.commit("SET_LOADING", true);
    cropper.value.getCroppedCanvas().toBlob((blob) => {
      if (blob) {
        const reader = new FileReader();
        reader.onloadend = () => {
          emit("change", reader.result);
          imageUrl.value = null;
          fileInput.value.value = "";
        };
        reader.readAsDataURL(blob);
      }
    });
  }
}

function cropImageCancel() {
  imageUrl.value = null;
  fileInput.value.value = "";
  internalShowCrop.value = true;
}

function openFile() {
  internalShowCrop.value = true;
  fileInput.value.click();
}

function fileDel() {
  emit("del");
}

watch(
  () => imageUrl.value,
  async () => {
    await nextTick(async () => {
      if (imageUrl.value) {
        if (cropper.value) cropper.value.destroy();

        await nextTick(() => {
          if (imageElement.value) {
            cropper.value = new Cropper(imageElement.value, {
              aspectRatio: props.aspectRatio ?? NaN,
              viewMode: props.viewMode,
            });
          }
        });
      }
    });
  },
  {
    immediate: true,
  },
);

onBeforeUnmount(() => {
  if (cropper.value) {
    cropper.value.destroy();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-avatar", [props.position]])
  }, [
    (props.url)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["avatar", { show: props.showImage === true }]),
          style: _normalizeStyle({
					'border-radius': __props.borderRadius,
				}),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (internalShowImage.value = true))
        }, [
          _createElementVNode("img", {
            src: props.url
          }, null, 8, _hoisted_1)
        ], 6))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(svgIcon), { icon: "no-image" })
        ])),
    (props.isEdit)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_3, [
            (props.url)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (__props.showEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-sm btn-primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (openFile()))
                      }, [
                        _createVNode(_unref(svgIcon), {
                          icon: "refresh",
                          size: "1.5rem"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (__props.showDel)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-sm btn-danger",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (fileDel()))
                      }, [
                        _createVNode(_unref(svgIcon), {
                          icon: "trash",
                          size: "1.5rem"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (__props.showUpload)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-sm btn-primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (fileInput.value.click()))
                      }, [
                        _createVNode(_unref(svgIcon), {
                          icon: "upload",
                          size: "1.5rem"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.upload")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          (imageUrl.value && internalShowCrop.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      ref_key: "imageElement",
                      ref: imageElement,
                      src: imageUrl.value,
                      alt: "Source Image"
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-default",
                      onClick: cropImage
                    }, _toDisplayString(_unref(t)("common.labels.save")), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-default",
                      onClick: cropImageCancel
                    }, _toDisplayString(_unref(t)("common.labels.cancel")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            ref_key: "fileInput",
            ref: fileInput,
            type: "file",
            onChange: fileSelect,
            accept: "image/*"
          }, null, 544)
        ], 64))
      : _createCommentVNode("", true),
    (props.showImage && internalShowImage.value)
      ? (_openBlock(), _createBlock(_unref(viewImage), {
          key: 3,
          image: props.url,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (internalShowImage.value = false))
        }, null, 8, ["image"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})